export const clientIdConfig = 'b0595a44-0726-11ec-9011-9457a55a403c';
export const scopeConfig =
    'account openid profile user-accounts user-data user-subscriptions validate-token';
export const codeChallengeMethodConfig = 'S256';
export const promptConfig = 'none';
export const responseTypeConfig = 'code';
export const redirectUriConfig =
    'https://eweb8.vfd2-testnet.de/meinvodafone/services/';
export const grantTypeConfig = 'authorization_code';
export const xApiKeyConfig = '7Exy0gETHbN7bV38D5Fs0THJIT4i01Nk';
export const headerContentTypeConfig = 'application/json';
export const clientSecretConfig = 'Li5uCmz8TcSBgce0Q';

export enum UserAssetsProp {
    Product = 'product',
    Internet = 'Internet',
    Activated = 'activated',
    Stack = 'stack',
    DSL = 'DSL',
    Cable = 'Cable',
    SubType = 'subType',
    KIP = 'KIP',
    UM = 'UM',
};
